//Styles
import Styles from "./SearchBox.module.scss";
import classnames from "classnames"

//Icon
import { ReactComponent as SearchIcon } from "../../icons/common/spotlight.svg"



interface SearchBoxProp{
    title?:string;
    placeholder?:string;
    value?:any;
    size?:"small"|"medium"|"large";
    onType?:(data:any)=>void;
}

const SearchBox = ({title="",size = "small" ,value = "" ,placeholder=`Searxh ${title}`, onType}:SearchBoxProp) => {

  const handleChange=(e:any)=>{
    onType?.(e.target.value)
  }

  return (
    <div className={classnames(Styles.container,Styles[size])} >
        <SearchIcon/>
        <input type="text" placeholder={placeholder} value={value} onChange={handleChange} />
    </div>
  )
}

export default SearchBox
